import { Select, SelectOption } from 'components/Select';
import { MessageOptionTooltip } from 'components/messages/messages_filter_selector/MessageOptionTooltip';
import { useRouter } from 'next/router';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { useState } from 'react';

type MessageFilter = {
  children: ReactNode;
  value: string;
  selectedText: string;
};

const MESSAGE_FILTERS: MessageFilter[] = [
  { children: 'All Messages', value: 'all', selectedText: 'All Messages' },
  {
    children: (
      <MessageOptionTooltip
        tooltipId="my_messages"
        optionText="My Messages"
        tooltipText="See conversations that only you’ve had with candidates. This will hide the conversations
        that your colleagues have with other educators."
      />
    ),
    value: 'initiatedBy',
    selectedText: 'My Messages',
  },
  {
    children: 'Unread Messages',
    value: 'unreadBy',
    selectedText: 'Unread Messages',
  },
  {
    children: (
      <MessageOptionTooltip
        tooltipId="unreplied_messages"
        optionText="Unreplied Messages"
        tooltipText="See conversations where the educator is the last
person to send a message. These conversations
may require a response from you."
      />
    ),
    value: 'unrespondedTo',
    selectedText: 'Unreplied Messages',
  },
];

type MessageFilterSelectorProps = {
  setFilter: Dispatch<SetStateAction<MessageFilter>>;
  setCurrentConversationId: Dispatch<SetStateAction<string>>;
};
export const MessageFilterSelector = ({
  setFilter,
  setCurrentConversationId,
}: MessageFilterSelectorProps) => {
  const router = useRouter();
  const { pathname } = router;

  const [selectedMessageFilter, setSelectedMessageFilter] = useState(MESSAGE_FILTERS[0]);

  return (
    <div className="flex flex-col gap-2 mb-2 w-full">
      <h1 className="font-bold text-2xl md:text-[32px] text-[20px] text-neutral-ink-blue max-w-7xl mb-4">
        My Messages
      </h1>
      <Select
        id="message_filter"
        fullWidth
        size="lg"
        placeholder="Select which messages are shown"
        onChange={(value) => {
          const newOption = MESSAGE_FILTERS.find((messageFilter) => messageFilter.value === value);
          setSelectedMessageFilter(newOption);
          setCurrentConversationId(null);
          void router.replace({ pathname });

          setFilter((prev) => {
            const messageFilters = {
              initiatedBy: undefined,
              unreadBy: undefined,
              unrespondedTo: undefined,
            };

            if (value === 'initiatedBy') {
              messageFilters[value] = 'current_employer_profile';
            }
            if (value === 'unreadBy' || value === 'unrespondedTo') {
              messageFilters[value] = 'current_employer';
            }

            return {
              ...prev,
              ...messageFilters,
            };
          });
        }}
        selectedOption={selectedMessageFilter}
        renderSelectedValue={(option: MessageFilter) => (
          <>
            <span className="font-bold">Show: </span>
            {option.selectedText}
          </>
        )}
      >
        {MESSAGE_FILTERS.map(({ children, value }) => (
          <SelectOption key={value.toString()} value={value}>
            {children}
          </SelectOption>
        ))}
      </Select>
    </div>
  );
};
